export function eventWindow(event, now = new Date()) {
  if (event.status !== 'ACTIVE') return 'inactive';
  const start = event.startsAt ? new Date(event.startsAt) : null;
  const end = event.endsAt ? new Date(event.endsAt) : null;
  if (start && now < start) return 'scheduled';
  if (end && now > end) return 'ended';
  return 'live';
}

export function formatEventRange(event) {
  const opts = { day: 'numeric', month: 'short' };
  const start = event.startsAt ? new Date(event.startsAt).toLocaleDateString('en-IN', opts) : null;
  const end = event.endsAt ? new Date(event.endsAt).toLocaleDateString('en-IN', opts) : null;
  if (start && end) return `${start} – ${end}`;
  if (end) return `Until ${end}`;
  if (start) return `From ${start}`;
  return 'No schedule';
}

export function pricingLabel(event) {
  if (event.pricingMode === 'PERCENT') return `${event.discountPercent || 0}% off selected items`;
  if (event.pricingMode === 'COUPON') return `Coupon ${event.couponCode || '—'}`;
  return 'Featured list · aisle prices';
}
